var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.2888mm",
    height: "11.2888mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1128.88 1128.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "signal-fil0",
    d: "M940.73 297.29l0 532.67c0,8.18 3.78,12.28 9.5,16.43 5.51,4 14.52,8.31 23.43,8.31l119.94 0c20.08,0 35.28,-10.66 35.28,-24.74l0 -532.67c0,-10.91 -17.37,-23.09 -32.92,-23.09l-122.3 0c-15.55,0 -32.93,12.18 -32.93,23.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal-fil1",
    d: "M705.55 402.83l0 427.13c0,8.18 3.78,12.28 9.5,16.43 5.5,4 14.51,8.31 23.43,8.31l119.94 0c20.08,0 35.28,-10.66 35.28,-24.74l0 -427.13c0,-10.9 -17.38,-23.09 -32.93,-23.09l-122.29 0c-15.56,0 -32.93,12.19 -32.93,23.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal-fil2",
    d: "M470.37 508.38l0 321.58c0,8.94 5.12,14.24 13.16,18.81 2.64,1.51 3.07,1.67 5.58,2.68 4.16,1.69 7.68,3.25 14.18,3.25l119.95 0c20.07,0 35.27,-10.66 35.27,-24.74l0 -321.58c0,-10.91 -17.37,-23.09 -32.92,-23.09l-122.3 0c-15.55,0 -32.92,12.18 -32.92,23.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal-fil3",
    d: "M235.18 615.57l0 214.39c0,8.94 5.13,14.24 13.16,18.81 2.65,1.51 3.07,1.67 5.59,2.68 4.16,1.69 7.68,3.25 14.18,3.25l119.94 0c20.08,0 35.28,-10.66 35.28,-24.74l0 -216.04c0,-5.72 -6.09,-12.24 -10.68,-15.6 -6.48,-4.75 -12.5,-7.48 -24.6,-7.48l-117.59 0c-19.14,0 -35.28,11.31 -35.28,24.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal-fil4",
    d: "M-0 721.12l0 108.84c0,14.26 19.07,24.74 32.92,24.74l119.95 0c20.08,0 35.28,-10.66 35.28,-24.74l0 -108.84c0,-8.93 -5.13,-14.23 -13.17,-18.81 -5.13,-2.92 -12.3,-5.93 -19.76,-5.93l-119.94 0c-20.08,0 -35.28,10.66 -35.28,24.74z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.92f23ba7ea21e8ef5950a306d66bb227.svg";
export { ForwardRef as ReactComponent };